import React from "react";
import { useCreate, useCreateSuggestionContext } from "react-admin";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  TextField,
} from "@mui/material";

export const CreateGraduation = () => {
  const { filter, onCancel, onCreate } = useCreateSuggestionContext();
  const [create] = useCreate();
  const [value, setValue] = React.useState(filter || "");

  const handleSubmit = (event: any) => {
    event.preventDefault();
    create(
      "graduations/crud",
      { data: { name: value } },
      {
        onSuccess: (data) => {
          setValue("");
          onCreate(data);
        },
      }
    );
  };

  return (
    <Dialog open onClose={onCancel}>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <TextField
            label="Nome da formação"
            value={value}
            onChange={(event) => setValue(event.target.value)}
            autoFocus
          />
        </DialogContent>
        <DialogActions>
          <Button type="submit">Salvar</Button>
          <Button onClick={onCancel}>Cancelar</Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};
